import React, { useState } from "react";
import { Box } from "@chakra-ui/react";
import { TabsComponent } from "../../components/TabsComponent";
import { useSubmissions } from "../../hooks/useSubmissions";
import { IndividualSubmissionPage } from "../IndividualSubmissionPage";
import { SummarySubmissionPage } from "../SummarySubmissionPage";

export const SubmissionsPage = ({ user, userRole }) => {
  const [tabs] = useState([
    { id: 1, name: "Individual" },
    { id: 2, name: "Summary" },
  ]);
  const { submissions, selectSubmission, selectSummarySubmission } =
    useSubmissions(user, userRole);
  return (
    <Box
      style={{
        maxWidth: "100%",
        margin: "0 auto",
      }}
    >
      <TabsComponent
        tabList={tabs}
        justifyContent="center"
        padding="0"
        tabPanels={[
          {
            panel: (
              <IndividualSubmissionPage
                submissions={submissions}
                selectSubmission={selectSubmission}
              />
            ),
          },
          {
            panel: (
              <SummarySubmissionPage
                submissions={submissions}
                selectSummarySubmission={selectSummarySubmission}
              />
            ),
          },
        ]}
      />
    </Box>
  );
};
